import Vue from "vue";
import $ from "jquery";
import { Component } from "vue-property-decorator";
import { ModalAlerteOptions } from "../modalComponents/modalAlerte/modalAlerte";
import { UtilisateurExterneDto } from "../../dto/GenApi.iNotPaie.Dto/UtilisateurExterneDto";
import { ServicesFactoryInstance } from "../Controls/ServicesFactory";
import { EventBus } from "../Controls/EventBus";
import EventConstants from "../Controls/EventConstants";
import ModalNotaire from "./modalNotaire/modalNotaire";
import { NotificationServiceInstance } from "../../shared/services/notification.service";

@Component({
	beforeRouteEnter(to, from, next) {
		next(v => {
			const vm = (v as listeNotaireComponent);
			vm.fetchData();
		});
	},
	beforeRouteUpdate(to, from, next) {
		next(v => {
			const vm = v as listeNotaireComponent;
			vm.fetchData();
		});
	},
	components: {
		ModalNotaire: require("./modalNotaire/modalNotaire.vue.html")
	}
})
export default class listeNotaireComponent extends Vue {
	public listeUtilisateursExternes: UtilisateurExterneDto[] = [];
	public dataReady = false;

	public fetchData(): void {
    	this.dataReady = false;
    	ServicesFactoryInstance.UtilisateurExterneService.getListe(data => {
			this.listeUtilisateursExternes = data;
    		this.dataReady = true;
    	});
	}

	public ouvrir(id: number): void {
		const modalNotaire = this.$refs.modalNotaire as ModalNotaire;
    	modalNotaire.Init(id);
    	$("#modalNotaire").modal("show");
	}

	public deleteItem(id: number): void {
    	const modalOptions: ModalAlerteOptions = new ModalAlerteOptions({
			message: "Souhaitez-vous vraiment supprimer cet utilisateur non salarié ?",
    		callBackYes: () => {
    			ServicesFactoryInstance.UtilisateurExterneService.delete(id, () => {
    				NotificationServiceInstance.SendSuccess("L'utilisateur a été supprimé avec succès.");
    				this.fetchData();
    			});
    		}
    	});

    	EventBus.$emit(EventConstants.MODAL_ALERT, modalOptions);
	}
}



// WEBPACK FOOTER //
// ./src/components/notaire/listeNotaire.ts